import { useNavigate } from "react-router-dom";
const Aboutus = () => {
    const navigate = useNavigate();
    return(
        <section data-aos="flip-right" className="aboutus items-center px-12 py-20 bg-white max-16 ">
            <div className="flex flex-col md:flex-row gap-8">
                <div className="md:w-1/2 flex justify-center">
                    <img src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621362/aboutus_ql5zwd.jpg" alt="About us" className="w-full max-w-sm rounded-lg shadow-md" loading="lazy"/>
                </div>
                <div className="pt-10">
                    <h3 className="text-3xl mb-4 text-schoolBlue text-bold text-lato text-left">About Us</h3>
                    <p className="text-gray-700 text-left text-lato leading-relaxed">
                        Founded in 2019, Springdales The School is dedicated to providing a high-quality education for young learners from preschool through 3rd grade. Our mission is to create a supportive and engaging environment where children can explore, learn, and grow.
                        <br/><br/> 
                        At Springdales The School, we believe in the importance of nurturing each child’s individuality. Our passionate and experienced teachers focus on developing not just academic skills, but also social and emotional growth. We incorporate play-based learning, hands-on activities, and creative projects to inspire curiosity and foster a lifelong love of learning.
                        <br/><br/> 
                        We are proud of our diverse community, where families from all backgrounds come together to support our students. Our school is a place where friendships are formed, creativity flourishes, and each child is encouraged to reach their full potential.
                        <br/><br/> 
                        We invite you to explore our programs and join us in our journey to make every child's educational experience memorable and enriching!
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 mt-8">
                        <button
                            className="hover:scale-105 transform text-[#0056B3] font-semibold py-2 px-6 transition duration-300 text-left text-rl"
                            onClick={() => navigate("/programs")}
                        >
                            <span className="text-bold">Learn More&nbsp;</span>
                            <span className="animate-pulse">&gt;&gt;&gt;&gt;</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );

};

export default Aboutus;